import format from "date-fns/format";
import addDays from "date-fns/addDays";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { currentTimeZoneString } from "utils/date-utils";
import DateRange, { DateRangeISO, DateRangeType } from "interfaces/DateRange";

export const getDateRangeQuery = (
  dateRange: DateRange
): racehorse360.IDateMatch | null => {
  if (!dateRange) return null;

  const result = {
    range: {
      relative: {
        startDate: {
          value: 0
        },
        endDate: {
          value: 0
        },
        timezone: currentTimeZoneString()
      }
    }
  };

  switch (dateRange.Type) {
    case DateRangeType.Today:
      result.range.relative.endDate.value = 1;
      return result;
    case DateRangeType.Tomorrow:
      result.range.relative.startDate.value = 1;
      result.range.relative.endDate.value = 2;
      return result;
    case DateRangeType.Next2Days:
      result.range.relative.endDate.value = 3;
      return result;
    case DateRangeType.Next3Days:
      result.range.relative.endDate.value = 4;
      return result;
    case DateRangeType.UpcomingDates:
      result.range.relative.startDate.value = 1;
      result.range.relative.endDate = null;
      return result;
    case DateRangeType.Custom:
      return {
        range: {
          absolute: {
            onOrAfter: format(dateRange.CustomDateRange[0], "yyyy-MM-dd"),
            before: format(
              addDays(dateRange.CustomDateRange[1], 1),
              "yyyy-MM-dd"
            )
          }
        }
      };
    case DateRangeType.Yesterday:
      result.range.relative.startDate.value = -1;
      result.range.relative.endDate.value = 0;
      return result;
    case DateRangeType.Last3Days:
      result.range.relative.startDate.value = -2;
      result.range.relative.endDate.value = 1;
      return result;
    default:
      return null;
  }
};

export const getDateRangeForStore = (dateRange: DateRange): DateRangeISO => {
  const storeDateRange: DateRangeISO = {
    Type: dateRange.Type,
    CustomDateRange: []
  };

  if (dateRange.Type === DateRangeType.Custom) {
    storeDateRange.CustomDateRange = dateRange.CustomDateRange.map(date =>
      date.toISOString()
    );
  }

  return storeDateRange;
};
